// based on rc-calendar 9.15.10
import Calendar from './src/';

export default Calendar;
